import { cx } from "../../../Util/classHelpers";
import styles from "./avatar.module.css";

const getInitials = (name) => {
  const initials = name
    .split(" ")
    .map((name) => name[0])
    .join("")
    .toUpperCase();
  return initials.length <= 2 ? initials : initials.slice(0, 1);
};

const Avatar = ({ name, size, variant = "default" }) => {
  return (
    <div className={cx(styles.avatar, styles[variant])} style={{ width: size, height: size }}>
      {getInitials(name)}
    </div>
  );
};
export default Avatar;
